import FormattedMessage from 'I18n/components/FormattedMessage';
import HubSpotAppLink from 'crm-links/common/components/HubSpotAppLink';
import { PRODUCT_TYPE_ID } from 'customer-data-objects/constants/ObjectTypeIds';
import { useProductId } from '../../contexts/ProductIdContext';
import { useSendCrmMessageTopic } from 'crm-message-bus/useSendCrmMessageTopic';
import { TOPIC_NAMES } from 'crm-message-bus/types/MessageTopics';
import { Button } from 'foundations-components/transitional/components/Button';
import { ALL_PROPERTIES_PANEL } from 'products-ui-components/constants/permissions';
import { usePermissionsContext } from '../../contexts/PermissionsContext';
import { useCallback } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export const ProductHighlightViewPropertiesButton = () => {
  const productId = useProductId();
  const {
    hasGate
  } = usePermissionsContext();
  const hasAllPropertiesPanelGate = hasGate(ALL_PROPERTIES_PANEL);
  const openPropertiesPanel = useSendCrmMessageTopic(TOPIC_NAMES.OPEN_ALL_PROPERTIES_PANEL);
  const handleOpenPropertiesPanel = useCallback(() => {
    openPropertiesPanel({
      objectTypeId: PRODUCT_TYPE_ID,
      objectId: String(productId)
    });
  }, [openPropertiesPanel, productId]);
  if (!productId) {
    return null;
  }
  if (hasAllPropertiesPanelGate) {
    return /*#__PURE__*/_jsx(Button, {
      use: "link",
      onClick: handleOpenPropertiesPanel,
      "data-test-id": "view-all-properties-button",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "actions.viewAllProperties"
      })
    });
  }
  return /*#__PURE__*/_jsx(HubSpotAppLink, {
    linkType: "CRM_OBJECT_RECORD_ALL_PROPERTIES",
    linkTypeProps: {
      includeEschref: true,
      objectTypeId: PRODUCT_TYPE_ID,
      objectId: productId
    },
    LinkComponentProps: {
      'data-test-id': 'view-all-properties-button'
    },
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "actions.viewAllProperties"
    })
  });
};